import { addNotify } from 'features/notify';
import { getErrorMessage } from 'shared/helpers/getErrorMessage';
import { SURVEY_STATUS } from 'services/api/SurveyApi/data';

const actionTypes = {
  ACTION_PROCESSING: 'survey/ACTION_PROCESSING',
  SET_STATUS_DATA: 'survey/SET_STATUS_DATA',
  SET_STATUS: 'survey/SET_STATUS',
  SET_CURRENT_QUESTION: 'survey/SET_CURRENT_QUESTION',
  OPEN_MODAL: 'survey/OPEN_MODAL',
  CLOSE_MODAL: 'survey/CLOSE_MODAL',
};

const openSurveyModal = () => ({ type: actionTypes.OPEN_MODAL });

const closeSurveyModal = () => ({ type: actionTypes.CLOSE_MODAL });

const loadSurveyStatus = () => async (dispatch, getState, extra) => {
  const { api } = extra;

  const response = await api.survey.getSurveyStatus();

  if (!response.success) {
    dispatch({ type: actionTypes.SET_STATUS_DATA, payload: null });
    return null;
  }

  const { status, surveyId, currentQuestionId, questions } = response.data;

  dispatch({
    type: actionTypes.SET_STATUS_DATA,
    payload: { status, surveyId, currentQuestionId, questions },
  });

  return response.data;
};

const getSurveyStatus = () => async dispatch => {
  const data = await dispatch(loadSurveyStatus());

  if (!data) return;

  const hasCurrentQuestion = data.questions.some(item => item.id === data.currentQuestionId);

  if (data.status !== SURVEY_STATUS.COMPLETED && data.surveyId && hasCurrentQuestion) {
    dispatch(openSurveyModal());
  }
};

const submitSurveyAnswer = (questionId, choiceIds) => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  const { surveyId, questions } = getState().survey;

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.survey.saveSurveyAnswer({ surveyId, questionId, choiceIds });

  if (response.success) {
    const currentIndex = questions.findIndex(item => item.id === questionId);
    const nextQuestion = currentIndex === -1 ? null : questions[currentIndex + 1];

    if (nextQuestion) {
      dispatch({ type: actionTypes.SET_STATUS, payload: SURVEY_STATUS.STARTED });
      dispatch({ type: actionTypes.SET_CURRENT_QUESTION, payload: nextQuestion.id });
    } else {
      dispatch({ type: actionTypes.SET_STATUS, payload: SURVEY_STATUS.COMPLETED });
    }
  } else {
    dispatch(addNotify(getErrorMessage(locale, response), 'error'));
    await dispatch(loadSurveyStatus());
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });

  return response.success;
};

export { actionTypes, getSurveyStatus, submitSurveyAnswer, openSurveyModal, closeSurveyModal };
